module.exports = __webpack_public_path__ + "static/media/minafintech.b0c09e8a.jpeg";